import { Checkbox, type CheckboxOptionType } from "antd/es";
import type { CheckboxValueType } from "antd/es/checkbox/Group";
import type { FilterDropdownProps } from "antd/es/table/interface";
import first from "lodash/first";
import React, { type FC } from "react";

import { Button } from "~/components/button";

import { Input, type InputRef } from "../input/Input";

const CheckboxGroup = Checkbox.Group;

export const SelectFilterDropdown: FC<FilterDropdownProps> = ({
	selectedKeys,
	setSelectedKeys,
	confirm,
	clearFilters,
	filters,
}) => {
	const options: Array<CheckboxOptionType> =
		filters?.map<CheckboxOptionType>((filter) => ({
			value: filter.value.toString(),
			label: filter.text,
		})) || [];

	return (
		<div className="p-2" data-testid="select-filter-dropdown">
			<CheckboxGroup
				className="mb-2 flex flex-col"
				onChange={(values: Array<string>) => setSelectedKeys(values)}
				options={options}
				value={selectedKeys as Array<CheckboxValueType>}
			/>
			<FilterButtons
				onCancelClick={() => {
					clearFilters?.();
					confirm({ closeDropdown: true });
				}}
				onSubmitClick={confirm}
				submitButtonText="apply"
			/>
		</div>
	);
};

export const SearchFilterDropdown: FC<FilterDropdownProps> = ({
	selectedKeys,
	setSelectedKeys,
	confirm,
	clearFilters,
	visible,
}) => {
	const inputRef = React.useRef<InputRef>(null);

	React.useEffect(() => {
		if (visible) {
			inputRef.current?.focus();
		}
	}, [visible]);

	return (
		<div className="p-2" data-testid="search-filter-dropdown">
			<Input
				className="mb-2 block w-48"
				data-testid="table-search-filter-input"
				onChange={(value) => setSelectedKeys(value ? [value] : [])}
				onConfirm={() => confirm({ closeDropdown: true })}
				placeholder="Search"
				ref={inputRef}
				value={first(selectedKeys)}
			/>
			<FilterButtons
				onCancelClick={() => {
					clearFilters?.();
					confirm({ closeDropdown: true });
				}}
				onSubmitClick={() => confirm({ closeDropdown: true })}
				submitButtonText="search"
			/>
		</div>
	);
};

interface FilterButtonProps {
	onCancelClick?: () => void;
	onSubmitClick?: () => void;
	cancelButtonText?: string;
	submitButtonText?: string;
}

const FilterButtons: FC<FilterButtonProps> = ({
	submitButtonText = "ok",
	cancelButtonText = "reset",
	onCancelClick,
	onSubmitClick,
}) => (
	<div className="flex items-center">
		<Button
			className="mr-2 w-full uppercase"
			data-testid="table-search-filter-button-reset"
			onClick={onCancelClick}
			size="sm"
			variant="tertiary"
		>
			{cancelButtonText}
		</Button>
		<Button
			className="w-full"
			data-testid="table-search-filter-button-submit"
			onClick={onSubmitClick}
			size="sm"
			variant="primary"
		>
			{submitButtonText}
		</Button>
	</div>
);
